/*
 * article-toc.js
 * Builds a table of contents from the H3 headings in a Dawn blog article,
 * assigns IDs to those headings, and highlights the active section on scroll.
 */
(function () {
  'use strict';

  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!base) base = 'section';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    used[slug] = true;
    return slug;
  }

  function buildLink(heading, level) {
    var li = document.createElement('li');
    li.className = 'article-toc__item article-toc__item--h' + level;
    var a = document.createElement('a');
    a.className = 'article-toc__link article-toc__link--h' + level;
    a.href = '#' + heading.id;
    a.textContent = heading.textContent.trim();
    a.dataset.tocLink = heading.id;
    li.appendChild(a);
    return li;
  }

  /*
   * Build a nested <ul>: each H2 is a top-level item; consecutive H3s that
   * follow it are nested in a child <ul> inside that item. H3s appearing
   * before any H2 are promoted to top level so nothing is dropped.
   */
  function buildTree(headings) {
    var root = document.createElement('ul');
    root.className = 'article-toc__list';
    var currentChildList = null;

    headings.forEach(function (item) {
      if (item.level === 2) {
        var li = buildLink(item.el, 2);
        root.appendChild(li);
        // Prepare a (lazy) child list for any H3s that follow.
        currentChildList = null;
        li._attachChild = function () {
          if (!currentChildList) {
            currentChildList = document.createElement('ul');
            currentChildList.className = 'article-toc__sublist';
            li.appendChild(currentChildList);
          }
          return currentChildList;
        };
        root._lastTop = li;
      } else {
        // H3
        if (root._lastTop && root._lastTop._attachChild) {
          root._lastTop._attachChild().appendChild(buildLink(item.el, 3));
        } else {
          // Orphan H3 before any H2 — promote to top level.
          root.appendChild(buildLink(item.el, 3));
        }
      }
    });

    return root;
  }

  function init(toc) {
    var content = document.querySelector('.article-template__content');
    if (!content) {
      toc.hidden = true;
      return;
    }

    var nodes = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
    if (nodes.length === 0) {
      toc.hidden = true;
      return;
    }

    var used = {};
    var headings = nodes.map(function (el) {
      if (!el.id) {
        el.id = slugify(el.textContent, used);
      } else {
        used[el.id] = true;
      }
      // Offset anchor jumps so the heading isn't hidden under any sticky header.
      el.style.scrollMarginTop = '6rem';
      return { el: el, level: el.tagName === 'H2' ? 2 : 3, id: el.id };
    });

    var lists = toc.querySelectorAll('[data-toc-list], [data-toc-list-mobile]');
    lists.forEach(function (list) {
      // Move the data attribute onto a freshly built nested tree, then swap it in.
      var tree = buildTree(headings);
      // Preserve whichever data hook the original <ul> carried.
      if (list.hasAttribute('data-toc-list')) {
        tree.setAttribute('data-toc-list', '');
      }
      if (list.hasAttribute('data-toc-list-mobile')) {
        tree.setAttribute('data-toc-list-mobile', '');
      }
      list.parentNode.replaceChild(tree, list);
    });

    setupScrollSpy(toc, headings);
    setupMobileClose(toc);
  }

  function setupMobileClose(toc) {
    // Close the mobile dropdown after a link is tapped.
    var details = toc.querySelector('[data-toc-mobile]');
    if (!details) return;
    toc.querySelectorAll('[data-toc-list-mobile] .article-toc__link').forEach(function (link) {
      link.addEventListener('click', function () {
        details.removeAttribute('open');
      });
    });
  }

  function setActive(toc, id) {
    toc.querySelectorAll('.article-toc__link').forEach(function (link) {
      var isActive = link.dataset.tocLink === id;
      link.classList.toggle('article-toc__link--active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function setupScrollSpy(toc, headings) {
    if (!('IntersectionObserver' in window)) return;

    var visible = {};

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          visible[entry.target.id] = entry.isIntersecting;
        });

        // Pick the first heading (in document order) currently in view.
        var current = null;
        for (var i = 0; i < headings.length; i += 1) {
          if (visible[headings[i].id]) {
            current = headings[i].id;
            break;
          }
        }

        // If nothing is in the observed band, fall back to the last heading
        // scrolled past so the rail still tracks position near the page bottom.
        if (!current) {
          for (var j = headings.length - 1; j >= 0; j -= 1) {
            if (headings[j].el.getBoundingClientRect().top < 0) {
              current = headings[j].id;
              break;
            }
          }
        }

        if (current) setActive(toc, current);
      },
      {
        // Trigger band: just below the top of the viewport.
        rootMargin: '-10% 0px -75% 0px',
        threshold: 0,
      }
    );

    headings.forEach(function (h) {
      observer.observe(h.el);
    });
  }

  function start() {
    document.querySelectorAll('[data-article-toc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();